import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../Images/logo192.png";
import { getAllMaintenanceScheduleById } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import { formatDateNumbers } from "../../../utils/dateFormatter";

DataTable.use(DT);

export default function StatusMaintenanceItems() {
  const [maintenancesItem, setMaintenancesItem] = useState([]);
  const dispatch = useDispatch();
  const { specificMaintenanceSchedule } = useSelector(
    (state) => state.maintenanceSchedule
  );
  const table = useRef();
  const [loading, setLoading] = useState(true);
  const { ScheduleId } = useParams();

  useEffect(() => {
    dispatch(getAllMaintenanceScheduleById(ScheduleId));
  }, [ScheduleId]);

  useEffect(() => {
    if (specificMaintenanceSchedule) {
      setMaintenancesItem(specificMaintenanceSchedule?.scheduleItems);
      console.log(specificMaintenanceSchedule);
      setLoading(false);
    }
  }, [specificMaintenanceSchedule]);
  function handlePrint() {
    window.print();
  }
  console.log("maintenancesItem", maintenancesItem);

  // =========== تحويل الحالة إلى عربي للطباعة =============
  function getStatusText(status) {
    if (status === "pending") return "قيد الانتظار";
    if (status === "completed") {
      return specificMaintenanceSchedule?.has_fire_extinguishers
        ? "تحت الصيانة"
        : "مكتملة";
    }
    if (status === "InProgress") return "جاري التنفيذ";
    return "غير معروف";
  }

  // =========== أعمدة الجدول في الشاشة ===========
  const screenColumns = [
    {
      title: "اسم العنصر الاساسي",
      data: "standardItem",
      render: (data) => data?.name,
    },
    { title: "الكمية", data: "quantity" },
    { title: "ملاحظات", data: "notes" },
    {
      title: "حالة العنصر",
      data: "status",
      render: (data) => {
        if (data === "pending") {
          return `<span className="text-warning"><i className='fa-solid fa-clock'></i> قيد الانتظار</span>`;
        } else if (data === "completed") {
          return `<span className="text-success"><i className='fa-solid fa-circle-check'></i> ${getStatusText(
            data
          )}</span>`;
        } else if (data === "InProgress") {
          return `<span className="text-primary"><i className='fa-solid fa-spinner fa-spin'></i> جاري التنفيذ</span>`;
        } else {
          return `<span className="text-secondary"><i className='fa-solid fa-question-circle'></i> غير معروف</span>`;
        }
      },
    },
    {
      title: "الصورة",
      data: "image",
      render: (a) =>
        a
          ? `<a href=${a} target="_blank" rel="noopener noreferrer">اضغط لمشاهدة الصورة</a>`
          : "",
    },
  ];

  return (
    <>
      {/* -------- HEADER FOR PRINT -------- */}
      <div className="print-header d-none d-print-block text-center py-3 mb-3 w-100">
        <div className="logo-print d-flex mb-2 align-items-center justify-content-between">
          <div>
            <h1 className="h6 mb-0 text-center">
              بصمة خبرة لأدوات الأمن والسلامة
            </h1>
            <h1 className="h6 mb-0 text-start">
              Experience Mark For Safety & Security Tools
            </h1>
            <p className="mb-0">
              Supply ,Installation & Maintenance توريد وتركيب وصيانة
            </p>
          </div>
          <figure className="me-3 mb-0 " dir="ltr">
            <img src={Logo} alt="logo" />
          </figure>
        </div>
      </div>

      {/* -------- SCREEN CONTENT -------- */}
      <div className="main">
        <button onClick={handlePrint} className="btn btn-primary d-print-none">
          طباعة
        </button>

        <div className="container-fluid mt-3">
          <div className="table-responsive d-print-none">
            {maintenancesItem?.length > 0 && !loading && (
              <DataTable
                data={maintenancesItem}
                columns={screenColumns}
                className="display table table-striped table-bordered"
                options={{
                  responsive: true,
                  searching: false,
                }}
                ref={table}
              />
            )}
          </div>
        </div>
      </div>

      {/* -------- PRINT TITLE -------- */}
      <div className="print-title d-none d-print-block text-center mb-3 w-100">
        <h2 className="text-center mx-3" style={{ fontSize: "32px" }}>
          <div>
            {specificMaintenanceSchedule?.has_fire_extinguishers
              ? "سند استلام طفايات"
              : "تقرير صيانة دورية"}
          </div>
          <div>
            {specificMaintenanceSchedule?.has_fire_extinguishers
              ? "Fire extinguisher receipt"
              : "Periodic maintenance report"}
          </div>
        </h2>
        <div>
          التاريخ:{" "}
          {formatDateNumbers(specificMaintenanceSchedule?.assignment_date)}
        </div>
      </div>

      {/* -------- PRINT TABLE (PLAIN) -------- */}
      <div className="print-table d-none d-print-block">
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "8px" }}>
                اسم العنصر الأساسي
              </th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>
                الكمية
              </th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>
                ملاحظات
              </th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>
                الحالة
              </th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>
                الصورة
              </th>
            </tr>
          </thead>

          <tbody>
            {maintenancesItem?.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #000", padding: "8px" }}>
                  {item?.standardItem?.name}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {item?.quantity}
                </td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>
                  {item?.notes}
                </td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>
                  {getStatusText(item?.status)}
                </td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>
                  {item?.image ? "Available" : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* -------- PRINT FOOTER DATA -------- */}
      <div className="print-footer-data d-none d-print-block w-100">
        <div style={{ padding: "15px", fontSize: "13px" }}>
          <div className="d-flex gap-3 justify-content-between">
            <div className="">
              <p>
                <input type="checkbox" /> صيانة لمرة واحدة
              </p>
              <p>
                اسم الفني:{" "}
                {specificMaintenanceSchedule?.assignedTechnician?.name}
              </p>
              <p>التوقيع: ____________________</p>
            </div>

            <div className="">
              <p>
                <input type="checkbox" /> صيانة ضمان
              </p>
              <p>
                اسم العميل:{" "}
                {
                  specificMaintenanceSchedule?.contractSchedule?.branch?.company
                    .name
                }
              </p>
              <p>التوقيع: ____________________</p>
            </div>

            <div className="">
              <p>
                <input type="checkbox" /> تحت العقد
              </p>
              <p>
                تليفون:{" "}
                {specificMaintenanceSchedule?.contractSchedule?.branch?.phone}
              </p>
            </div>
          </div>

          <p className="mt-3 text-center" style={{ fontWeight: "bold" }}>
            This is not a payment receipt. Customer should request it upon
            payment
            <br />
            هذا لا يعتبر سند استلام نقدي، يجب على العميل طلب سند رسمي في حال
            سداد أي مبلغ
          </p>
        </div>
      </div>

      {/* -------- FIXED FOOTER FOR EVERY PAGE -------- */}
      <div className="print-footer-fixed d-none d-print-block">
        <div className="footer-content">
          <div className="footer-top text-white">
            <span className="text-white">
              المركز الرئيسي: جدة - فرع الرياض - فرع الدمام
            </span>
          </div>
          <div className="footer-bottom">
            <div className="footer-item">
              <i className="fa fa-phone"></i> 0531955966
            </div>
            <div className="footer-item">
              <i className="fa fa-phone"></i> 0541344107
            </div>
            <div className="footer-item">
              <i className="fa fa-envelope"></i> ali@experience-mark.com
            </div>
            <div className="footer-item">
              <i className="fa fa-globe"></i> www.experiencemark.com
            </div>
          </div>
        </div>
      </div>

      {/* -------- PRINT CSS -------- */}
      {/* -------- PRINT CSS -------- */}
      <style>
        {`
  @media print {
    /* إخفاء كل عناصر الطباعة الافتراضية */
    @page {
      margin: 0;
      size: A4;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    /* إخفاء التايتل والتاريخ والوقت من المتصفح */
    html, body {
      margin: 0 !important;
      padding: 0 !important;
      height: 100% !important;
      overflow: visible !important;
    }

    body {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    /* إخفاء الهيدر والفوتر الافتراضي من المتصفح */
    header, footer {
      display: none !important;
    }

    .dataTable, .table-responsive, .display {
      display: none !important;
    }

    /* الهيدر المطبوع */
    .print-header {
      display: block !important;
      margin: 0 !important;
      padding: 15px 20px !important;
      border-bottom: 2px solid #0097a7;
      background: white;
    }

    .print-header .logo-print img {
      max-width: 80px;
      height: auto;
    }

    /* العنوان والتاريخ - إزالة المارجن من فوق */
    .print-title {
      display: block !important;
      margin: 10px 0 10px 0 !important;
      padding: 0 20px !important;
    }

    .print-title h2 {
      font-size: 24px !important;
      margin-bottom: 8px !important;
      margin-top: 0 !important;
    }

    /* الجدول - إزالة المارجن من فوق */
    .print-table {
      display: block !important;
      width: 100%;
      padding: 0 20px;
      margin-top: 0 !important;
      margin-bottom: 0;
    }

    .print-table table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      font-size: 12px;
      margin-bottom: 0;
      margin-top: 0 !important;
    }

    .print-table th {
      background-color: #f8f9fa !important;
      font-weight: bold;
      text-align: center;
      border: 1px solid #000;
      padding: 8px 6px;
      vertical-align: middle;
    }

    .print-table td {
      border: 1px solid #000;
      padding: 6px;
      vertical-align: middle;
      word-wrap: break-word;
    }

    .print-table tbody tr:nth-child(even) {
      background-color: #f9f9f9 !important;
    }

    /* السماح للجدول بالتكسر عبر الصفحات */
    tr {
      break-inside: auto !important;
      page-break-inside: auto !important;
    }
    
    td, th {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
    }

    table {
      page-break-inside: auto !important;
    }

    tbody {
      page-break-inside: auto !important;
      page-break-after: auto !important;
    }

    thead {
      display: table-header-group !important;
    }

    /* البيانات فوق الفوتر - مرة واحدة في آخر صفحة فقط */
    .print-footer-data {
      display: block !important;
      background: white;
      padding: 10px 20px;
      border-top: 2px solid #ddd;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      page-break-before: auto !important;
    }

    .print-footer-data p {
      // margin: 3px 0;
      font-size: 11px;
    }

    .print-footer-data .d-flex {
      gap: 15px;
    }

    .print-footer-data input[type="checkbox"] {
      margin-left: 5px;
    }

    /* الفوتر الثابت في كل صفحة */
    .print-footer-fixed {
      display: block !important;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(to right, #0097a7, #00796b) !important;
      color: white !important;
      font-size: 11px;
      z-index: 9999;
    }

    .footer-content {
      padding: 8px 20px;
    }

    .footer-top {
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 6px;
      border-bottom: 1px solid rgba(255,255,255,0.3);
      padding-bottom: 4px;
    }

    .footer-bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 10px;
      font-size: 10px;
    }

    .footer-item {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .footer-item i {
      font-size: 11px;
    }

    .d-print-none {
      display: none !important;
    }

    /* منع الصفحات الفارغة وتوزيع المحتوى */
    .main {
      height: auto !important;
      min-height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .container-fluid {
      padding: 0 !important;
      margin: 0 !important;
    }

    /* التأكد من ملء الصفحة بالكامل */
    body::before,
    body::after {
      display: none !important;
    }

    /* إضافة مسافة سفلية للمحتوى لتجنب التداخل مع الفوتر الثابت */
    body {
      margin-bottom: 100px !important;
    }
  }

  .print-header {
    display: none;
  }

  .print-footer-fixed {
    display: none;
  }

  .print-footer-data {
    display: none;
  }
`}
      </style>
    </>
  );
}
